<template>
  <div class="slide-filters">
    <ProductFilter
      class="slide-filters-item"
      :disable="productsDisable"
      :items="products"
      :selected-item="selectedProduct"
    >
      Продукт
    </ProductFilter>
    <Divider type="vertical" class="slide-filters-divider" />
    <PartnerFilter
      class="slide-filters-item"
      :disable="partnersDisable"
      :items="partners"
      :selected-item="selectedPartners"
    >
      Партнер
    </PartnerFilter>
    <Divider type="vertical" class="slide-filters-divider" />
    <PeriodFilter
      class="slide-filters-item"
      :is-disabled="periodDisable"
      :menu-items="periodItems"
      :menu-selected-item="periodSelectedItem"
      :calendar-mode="period.mode"
      :calendar-value="period.value"
      :calendar-is-range="period.range"
      :calendar-events="period.events"
      :calendar-holidays="period.holidays"
      :calendar-disabled-dates="period.disabledDates"
      :calendar-start-year="period.startYear"
      :calendar-end-year="period.endYear"
      :calendar-selected-period="period.selectedPeriod"
      :calendar-max-range-days="period.maxRangeDays"
      :calendar-max-range-weeks="period.maxRangeWeeks"
      :calendar-max-range-months="period.maxRangeMonths"
      :options="options"
    >
      Період
    </PeriodFilter>
  </div>
</template>

<script>
import PartnerFilter from './partner-filter';
import PeriodFilter from './period-filter';
import ProductFilter from './product-filter';
import { Divider } from '@/shared/ui/divider';

export default {
  props: {
    productsDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    products: {
      type: Array,
      required: true,
    },
    selectedProduct: {
      type: Object,
      required: false,
      default: () => {},
    },
    partnersDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    partners: {
      type: Array,
      required: true,
    },
    selectedPartners: {
      type: Object,
      required: false,
      default: () => {},
    },
    periodDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    periodItems: {
      type: Array,
      required: true,
    },
    periodSelectedItem: {
      type: Object,
      required: false,
      default: () => {},
    },
    period: {
      type: Object,
      required: false,
      default: () => ({
        mode: 'days',
        value: null,
        range: false,
        events: [],
        holidays: [],
        disabledDates: [],
        startYear: null,
        endYear: null,
        selectedPeriod: {},
        maxRangeDays: null,
        maxRangeWeeks: null,
        maxRangeMonths: null,
      }),
    },
    options: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  components: { ProductFilter, PartnerFilter, PeriodFilter, Divider },
};
</script>

<style lang="scss" scoped>
.slide-filters {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 550px) {
    flex-wrap: wrap;
  }

  &-divider {
    height: 10px;

    @media (max-width: 550px) {
      display: none;
    }
  }

  @media (max-width: 550px) {
    &-item {
      margin: 0 24px 16px 0;
    }
  }
}
</style>
